<template>
  <div class="home">
    <!-- <keep-alive>
    </keep-alive> -->
    <router-view />

  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
